/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-09 14:43:41
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 12:33:24
 * @FilePath: /wemeet-web-activity/src/pages/payend/component/phoneInput/index.tsx
 * @Description: 输入手机号输入区域
 */
import React, { memo, useContext, useState } from 'react';
import { Select, Button, message } from '@tencent/tea-component';
import { countryData } from "./countryData";
import styles from "./index.module.scss";
import { Validator } from "./validator";
import { ThemeContext } from "../../../BuyModal/context";
// import dataReport from '@utils/data-report';
import TicketRegistPageModifyPhone from "../../../quickServices/TicketRegistPageModifyPhone";
const SEPARATOR = '^_^';
// 海外手机号区号
const countryCodeOptions = countryData.map(item => ({
  text: /*#__PURE__*/React.createElement("div", {
    key: `${item.country}${item.name}+${item.areaCode}${item.code_name || ''}`
    // className={styles['code-option-item']}
  }, /*#__PURE__*/React.createElement("span", {
    title: item.name
  }, item.name), /*#__PURE__*/React.createElement("span", null, "+", item.areaCode)),
  value: `${item.areaCode}${SEPARATOR}${item.code_name}`
}));
const PhoneInput = ({
  ticketId,
  success,
  className
}) => {
  const {
    http,
    dataReport
  } = useContext(ThemeContext);
  const [areaCode, setAreaCode] = useState('86');
  const [areaCodeName, setAreaCodeName] = useState('CN');
  const [resetPhone, setResetPhone] = useState('');
  const changeAreaCode = areaCode => {
    const array = areaCode?.split(SEPARATOR);
    setAreaCode(array?.[0]);
    setAreaCodeName(array?.[1]);
  };
  const changePhone = () => {
    dataReport('e#event_ticket_paid#number_confirm_button#click');
    // const phoneReg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
    if (!Validator.isPhone(resetPhone)) {
      message.error({
        content: '请输入正确的手机号码'
      });
      return;
    }
    TicketRegistPageModifyPhone({
      phone_code: areaCode,
      phone_num: resetPhone,
      ticket_id: ticketId
    }, http).then(res => {
      if (res.code === 0) {
        message.success({
          content: '手机号修改成功'
        });
        success(resetPhone);
        return;
      }
      message.error({
        content: res.msg || '网络异常请重试'
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles['payend-input']} ${className || ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "payend-input-zone"
  }, /*#__PURE__*/React.createElement(Select, {
    placeholder: areaCode,
    className: styles['phone-select'],
    type: "simulate",
    appearance: "button",
    searchable: true,
    boxSizeSync: true,
    listHeight: 300,
    options: countryCodeOptions,
    value: `${areaCode}${SEPARATOR}${areaCodeName}`,
    onChange: changeAreaCode,
    boxClassName: styles['country-code-select-box'],
    button: `+${areaCode}`,
    filter: (inputValue, option) => {
      const keyword = inputValue?.toLowerCase().trim();
      // @ts-ignore
      const name = option.text?.key?.toLowerCase();
      return name?.includes(keyword);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("input", {
    onChange: e => setResetPhone(e.target.value),
    type: "tel",
    placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801",
    autoFocus: true
  })), /*#__PURE__*/React.createElement(Button, {
    disabled: !resetPhone,
    className: "size-s",
    type: "primary",
    onClick: changePhone
  }, "\u786E\u5B9A"));
};
export default /*#__PURE__*/memo(PhoneInput);